import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level4};
  flex: 1;
  min-height: 200px;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${({ theme }) => theme.colors.outlineVariant};
  border-top-color: ${({ theme }) => theme.colors.onSurface};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingText = styled.div`
  font-size: ${({ theme }) => theme.font.bodyMedium.fontSize};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;
